module.exports = __webpack_public_path__ + "img/hx-yjybb-w.c9a8c0f6.svg";